import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Content } from "./Content";

interface CommunityHeaderProp {
  className?: string;
}

export const CommunityHeader = ({ className }: CommunityHeaderProp) => {
  const { currentCommunity } = usePaywallCheckoutContext();

  return (
    <div
      className={classNames(
        "flex flex-row justify-center py-[1.625rem] md:py-[2.625rem] lg:justify-start lg:py-10",
        className,
      )}
    >
      <Content currentCommunity={currentCommunity} />
    </div>
  );
};
